import * as R from 'ramda'

const sharedWhitelist = R.pick(['smartySharedData'])

export const loadState = () => {
  // We return undefined in non-success scenarios to allow reducers to hydrate the store with default values
  // This path is probably hit if the user doesn't allow use of local storage

  try {
    // Shared data
    const serializedSharedState = localStorage.getItem('smartySharedData')

    if (!serializedSharedState) {
      return undefined
    }

    const parsedSharedState = JSON.parse(serializedSharedState)
    return sharedWhitelist(parsedSharedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = ({ smartySharedData }) => {
  try {
    const sharedStateToSave = {
      smartySharedData,
    }
    const serializedSharedState = JSON.stringify(sharedStateToSave)
    localStorage.setItem('smartySharedData', serializedSharedState)
  } catch (err) {
    // Ignore write errors for now. Log them when we set that up.
  }
}
